<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="container_id"
      :focused-row-index="0"
      :show-borders="false"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="20" />
      <dx-pager :show-page-size-selector="true" :show-info="true" :allowed-page-sizes="[5, 10, 20, 30, 50]" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="name" caption="Container Name" />
      <dx-column data-field="container_id" caption="Container ID" />
      <dx-column data-field="status" caption="Status" cell-template="statusCellTemplate" />
      <dx-column data-field="ports" caption="Ports" />
      <dx-column data-field="image" caption="Image" />
      <dx-column data-field="restart_policy" caption="Restart Policy" />
      <dx-column data-field="command" caption="Command" />
      <dx-column data-field="created" caption="Created At" />      

      <template #statusCellTemplate="{ data }">
        <span :class="['tag-pill', getStatusTagClass(data.value)]">
          {{ data.value }}
        </span>
      </template>
    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>


<script>
  import {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow
  } from 'devextreme-vue/data-grid';
  import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
  import axios from 'axios';

  export default {
    name: 'DockerContainerGrid',
    components: {
      DxDataGrid,
      DxColumn,
      DxPaging,
      DxPager,
      DxFilterRow,
      DxLoadIndicator
    },
    data() {
      return {
        title: 'Running Docker Containers',
        loading: true,
        dataSource: []
      };
    },
    mounted() {
      this.loadContainers();
    },
    methods: {
      async loadContainers() {
        try {
          const response = await axios.get('/api/internal/docker/settings');
          this.dataSource = response.data.filtered_containers || [];
        } catch (error) {
          console.error('[Docker] Failed to load container data:', error);
        } finally {
          this.loading = false;
        }
      },
      getStatusTagClass(status) {
        if (!status) return 'tag-default';

        const s = status.toLowerCase();
        if (s.includes('healthy')) return 'tag-ok';
        if (s.includes('up')) return 'tag-running';
        if (s.includes('paused')) return 'tag-paused';
        if (s.includes('exited')) return 'tag-stopped';
        if (s.includes('created')) return 'tag-created';
        if (s.includes('dead')) return 'tag-dead';

        return 'tag-unknown';
      }
    }
  };
</script>


<style scoped>
    .loading-overlay {
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 10;
    }
</style>

<style>
  .tag-ok {
    background-color: #4caf50; /* Green: healthy or OK */
    color: white;
  }

  .tag-running {
    background-color: #2196f3; /* Blue: general running (Up) */
    color: white;
  }

  .tag-paused {
    background-color: #ffeb3b; /* Yellow: paused */
    color: #000;
  }

  .tag-stopped {
    background-color: #ff9800; /* Orange: exited */
    color: white;
  }

  .tag-created {
    background-color: #9c27b0; /* Purple: created but not started */
    color: white;
  }

  .tag-dead {
    background-color: #000000; /* Black: dead container */
    color: white;
  }

  .tag-default {
    background-color: #9e9e9e; /* Grey: default/unknown */
    color: white;
  }

  .tag-unknown {
    background-color: #795548; /* Brown: fallback/undefined state */
    color: white;
  }

  /* Optional: make all tags visually consistent */
  .tag-ok, .tag-running, .tag-paused, .tag-stopped,
  .tag-created, .tag-dead, .tag-default, .tag-unknown {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.9em;
    display: inline-block;
    text-transform: capitalize;
  }
</style>

